import { FC, ReactNode } from 'react';
import {
  usePersistedTimeRangeProvider,
  useTimeRangeProvider,
  TimeRangeSettings,
  PersistedTimeRangeSettings,
} from './useTimeRangeProvider';
import { TimeRangeContext } from './context';

interface Props {
  children?: ReactNode;
}

/**
 * Time range provider to group independent components under the same time range settings
 */
const BaseProvider: FC<Props & TimeRangeSettings> = ({ children, ...initialTimeRange }) => {
  const contextValue = useTimeRangeProvider(initialTimeRange);
  return <TimeRangeContext.Provider value={contextValue}>{children}</TimeRangeContext.Provider>;
};

/**
 * Time range provider to group independent components under the same time range settings
 * State persisted in locale storage
 */
const PersistedTimeRangeProvider: FC<Props & PersistedTimeRangeSettings> = ({
  children,
  ...initialTimeRange
}) => {
  const contextValue = usePersistedTimeRangeProvider(initialTimeRange);
  return <TimeRangeContext.Provider value={contextValue}>{children}</TimeRangeContext.Provider>;
};

export const TimeRangeProvider = BaseProvider as typeof BaseProvider & {
  Persisted: typeof PersistedTimeRangeProvider;
};

TimeRangeProvider.Persisted = PersistedTimeRangeProvider;
